export enum Meridiem {
  AM = 'AM',
  PM = 'PM',
}
